import React, { useState } from "react";
import { faPlus, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { get } from "lodash";
import { Form } from "react-bootstrap";
import { Field, FieldArray } from "formik";
import { FieldInput, FieldNotSpecialChar } from "../Forms";
import { faCheck, faTimes } from "@fortawesome/pro-light-svg-icons";
import { clearFieldValues, required } from "../../utils";
import { faEdit } from "@fortawesome/pro-solid-svg-icons";
import AddToolTip from "../AddToolTip";

//if it is exists and deleted
// then make it is deleted false

function findKeyByDescription(description, data) {
  for (const key in data) {
    if (data[key].description === description) {
      return key;
    }
  }
}
function findValByDescription(description, data) {
  for (const key in data) {
    if (data[key].description === description) {
      return data[key];
    }
  }
}

const LoanDocumentCard = ({
  values,
  setFieldValue,
  handleChange,
  fields,
  isEdit,
  isSave,
  setFieldError,
  fieldArrayName,
}) => {
  // console.log("HEEEEEvalues", values);
  // console.log("HEEEEEfields", fields);

  // const documentTypeString = fieldArrayName;
  // fields.withDrawalType != null
  //   ? fields.withdrawalDocumentType
  //   : fields.loanDocumentType;

  // console.log("documentTypeString", documentTypeString);
  const [addNewDocument, setAddNewDocument] = useState(false);
  const [editDocument, setEditDocument] = useState(false);
  const [descriptionLength, setDescriptionLength] = useState(false);
  const loanDocumentType = get(values, fieldArrayName, [])?.filter(
    (_) => !_.isDeleted
  );

  // console.log("loanDocumentType", loanDocumentType);

  const AddAndEditDocumentCard = (title, show, setShow, push, i, doc) => {
    const index = i;
    let desc = null;

    if (doc != null) {
      desc = doc.description;
    }

    // console.log("title", title);
    // console.log("show", show);
    // console.log("id", i);
    // console.log("doc", doc);
    // ; description;

    // const desc = doc.description;
    // const fieldName = `loanDocumentType.${index}.description`;
    return (
      <div className="create-new-document">
        <p className="ft-12 grey-text mb-1">{title} document name</p>
        <div className="d-flex justify-content-between align-item-baseline">
          <div>
            <Field
              size="md"
              name={fields.documentDescription}
              type="text"
              autoComplete="off"
              autoFocus={true}
              value={values[fields.documentDescription]}
              onChange={handleChange}
              preventSpecialCharacter={true}
              component={FieldInput}
              validate={required}
              // validate={
              //   (value) => {
              //     return value > 10
              //     ? "LO001 : Loan Document type shpuld not exeed 50 characters"
              //     : "" }
              //   }
            />
          </div>
          <div>
            <span
              className="doc-check mr-2 ft-16"
              onClick={() => {
                if (
                  !["", null, undefined].includes(values?.documentDescription)
                ) {
                  if (
                    title == "Create" &&
                    values[fieldArrayName].some(
                      (_) => _.description === values.documentDescription
                    )
                  ) {
                    // console.log("gfatvasghf");
                    // console.log(values?.documentDescription);
                    const dataVal = findValByDescription(
                      values?.documentDescription,
                      get(values, fieldArrayName, [])
                    );
                    // console.log(dataVal);
                    if (
                      dataVal.isDeleted != null &&
                      dataVal.isDeleted == true
                    ) {
                      let key = i;

                      //doc.description; intially used

                      key = findKeyByDescription(
                        values?.documentDescription,

                        get(values, fieldArrayName, [])
                      );
                      //instead showing error  remove input

                      setFieldValue(
                        `${fieldArrayName}[${key}].isDeleted`,
                        false
                      );
                      setFieldError(fields.documentDescription, null);
                      setFieldValue([fields.documentDescription], null);
                      setDescriptionLength(false);
                      setAddNewDocument(editDocument ? false : !addNewDocument);
                      setEditDocument(false);
                    } else {
                      setFieldError(
                        fields.documentDescription,
                        "Document already added"
                      );
                    }

                    /*
                    check the description  from input is already exists or not
                    find key by description
                    set isDeleted false
                    */
                    // check existence

                    // if(setFieldValue(`${fields.loanDocumentType}[${key}].isViewOnly`, !doc.isViewOnly);

                    // let updatedValues;
                    // updatedValues = clearFieldValues({
                    //   values,
                    //   fieldsToClear: [fields.documentDescription],
                    // });
                  } else if (values?.documentDescription.length > 50) {
                    setDescriptionLength(true);
                  } else {
                    if (title == "Create") {
                      push({
                        description: values.documentDescription,
                        isRequired: false,
                        isAdded: true,
                        isViewOnly: true,
                      });
                      // console.log("values2", values.loanDocumentType);
                      setFieldValue(fields.documentDescription, null);
                      setFieldError(fields.documentDescription, null);
                    } else {
                      const key = findKeyByDescription(
                        doc.description,
                        get(values, fieldArrayName, [])
                      );

                      setFieldValue(
                        `${fieldArrayName}[${key}].isViewOnly`,
                        !doc.isViewOnly
                      );
                      setFieldValue(
                        `${fieldArrayName}[${key}].description`,
                        values.documentDescription
                      );
                      setFieldValue(fields.documentDescription, null);
                    }
                    setShow(!show);
                  }
                }
              }}
            >
              <FontAwesomeIcon className="mt-2" icon={faCheck} />
            </span>
            <span
              className="doc-cross mr-2 ft-16"
              onClick={() => {
                let key = i;

                //doc.description; intially used
                if (desc != null) {
                  key = findKeyByDescription(
                    desc,
                    get(values, fieldArrayName, [])
                  );
                }
                // key

                editDocument &&
                  setFieldValue(
                    `${fieldArrayName}[${key}].isViewOnly`,
                    !doc.isViewOnly
                  );
                setFieldError(fields.documentDescription, null);
                setFieldValue([fields.documentDescription], null);
                setDescriptionLength(false);
                setAddNewDocument(editDocument ? false : !addNewDocument);
                setEditDocument(false);
              }}
            >
              <FontAwesomeIcon className="mt-2" icon={faTimes} />
            </span>
          </div>
        </div>
        <>
          {descriptionLength && (
            <div className={"ft-12"} style={{ color: "#ff5050" }}>
              Loan Document type should not exceed 50 characters
            </div>
          )}
        </>
      </div>
    );
  };

  return (
    <FieldArray
      name={fieldArrayName}
      render={({ push, remove }) => (
        <>
          <div className="loan-document-container">
            <p className="ft-14 fw-500">Document Section</p>

            {loanDocumentType.map((doc, i) => {
              return (
                <>
                  {doc.isViewOnly ? (
                    <>
                      <div className="d-flex justify-content-start align-item-baseline p-3">
                        <div className="ft-14 w-10">{i + 1}</div>

                        {!doc.isAdded ? (
                          <div className="ft-12 w-75">
                            <AddToolTip name={`${doc.description} required?`} />
                          </div>
                        ) : (
                          <div className="d-flex flex-column w-75">
                            <div className="ft-12 mb-0">
                              <AddToolTip
                                name={`${doc.description} required?`}
                              />
                            </div>
                            <div>
                              <span className=" border-right mr-2 line-color">
                                <FontAwesomeIcon
                                  //className="mt-2 mr-2 blue-text cursor-pointer"
                                  className={
                                    isEdit
                                      ? "cursor-not-allowed"
                                      : "pointer mt-2 mr-2 blue-text cursor-pointer"
                                  }
                                  ic
                                  icon={faEdit}
                                  onClick={() => {
                                    if (!isEdit) {
                                      const key = findKeyByDescription(
                                        doc.description,
                                        get(values, fieldArrayName, [])
                                      );

                                      setEditDocument(!editDocument);
                                      setFieldValue(
                                        `${fieldArrayName}[${key}].isViewOnly`,
                                        !doc.isViewOnly
                                      );
                                      setFieldValue(
                                        fields.documentDescription,
                                        doc.description
                                      );
                                    }
                                  }}
                                />
                              </span>

                              <FontAwesomeIcon
                                // className="mt-2"
                                className={
                                  isEdit
                                    ? "cursor-not-allowed mt-2 grey-text"
                                    : "pointer mt-2"
                                }
                                icon={faTrashAlt}
                                onClick={() => {
                                  // console.log("LOAN DOC DEl", loanDocumentType);
                                  const key = findKeyByDescription(
                                    doc.description,
                                    get(values, fieldArrayName, [])
                                  );

                                  if (!isEdit) {
                                    setFieldValue(
                                      `${fieldArrayName}[${key}].isDeleted`,
                                      true
                                    );
                                    // remove(i);

                                    //wait 1.5 second and print
                                    // setTimeout(() => {
                                    //   console.log(
                                    //     "LOAN DOC DEl2222",
                                    //     loanDocumentType
                                    //   );
                                    // }, 1500);

                                    // remove(i);
                                  }
                                }}
                              />
                            </div>
                          </div>
                        )}
                        <Form.Check
                          type="switch"
                          //className="w-15"
                          id={`custom-switch-${i}`}
                          onChange={() => {
                            const key = findKeyByDescription(
                              doc.description,
                              get(values, fieldArrayName, [])
                            );

                            setFieldValue(
                              `${fieldArrayName}[${key}].isRequired`,
                              !doc.isRequired
                            );
                          }}
                          className={
                            isEdit ? "cursor-not-allowed w-15" : "pointer w-15"
                          }
                          checked={doc?.isRequired}
                          disabled={isEdit && !isSave}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {AddAndEditDocumentCard(
                        "Edit",
                        editDocument,
                        setEditDocument,
                        push,
                        i,
                        doc
                      )}
                    </>
                  )}
                </>
              );
            })}
            {!addNewDocument && !editDocument ? (
              <div
                className="d-flex add-document-btn justify-content-center align-item-baseline fw-400 ft-12 cursor-pointer"
                onClick={() => {
                  if (!isEdit) {
                    setAddNewDocument(!addNewDocument);
                  }
                }}
              >
                <FontAwesomeIcon className="mr-1 mt-1 ft-10" icon={faPlus} />
                <div className={isEdit ? "cursor-not-allowed" : "pointer"}>
                  Add Document{" "}
                </div>
              </div>
            ) : !editDocument ? (
              <>
                {AddAndEditDocumentCard(
                  "Create",
                  addNewDocument,
                  setAddNewDocument,
                  push,
                  null,
                  null
                )}
              </>
            ) : null}
          </div>
        </>
      )}
    />
  );
};

export default LoanDocumentCard;
